export default "__VITE_ASSET__CYpiAiBP__"